import React from 'react';

import CourseOrSpecializationItem from './CourseListing';

const CourseListingPage = ({ courseData, specializationData }: any) => {
  return (
    <>
      {courseData?.length > 0 || specializationData?.length > 0 ? (
        <div className="mt-5 flex flex-col gap-y-4 px-3 lg:px-0">
          {/* Render courses */}
          {courseData?.map((courses: any) => (
            <CourseOrSpecializationItem key={courses?.id} item={courses} type="course" />
          ))}

          {/* Render specializations */}
          {specializationData?.length > 0 &&
            specializationData?.map((specialization: any) => (
              <CourseOrSpecializationItem key={specialization.id} item={specialization} type="specialization" />
            ))}
        </div>
      ) : (
        <div className="flex h-60 items-center justify-center">No data found...</div>
      )}
    </>
  );
};

export default CourseListingPage;
